import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import composePaginationLinkTo from '@atoms/Pagination/composePaginationLinkTo';
import getNextOffset from '@atoms/Pagination/getNextOffset';
import getPageNumber from '@atoms/Pagination/getPageNumber';
import getPreviousOffset from '@atoms/Pagination/getPreviousOffset';
import { useSearchQuestion, useSearchResults } from '@context/DataContext';

const PaginationControl = ({ direction = 'previous', itemType = 'link' }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { pagination, resultsSummary: summary } = useSearchResults();
  const { setPage } = useSearchQuestion();
  const { limit } = pagination;

  const labelPrefix = direction === 'previous' ? 'Previous' : 'Next';
  const icon =
    direction === 'previous' ? (
      <svg className="icon icon--chevron left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
        <path fill="currentColor" fillRule="evenodd" d="M1.92 1.18L5.72 5l-3.8 3.83L3.08 10l5-5-5-5-1.16 1.18z"></path>
      </svg>
    ) : (
      <svg className="icon icon--chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
        <path fill="currentColor" fillRule="evenodd" d="M1.92 1.18L5.72 5l-3.8 3.83L3.08 10l5-5-5-5-1.16 1.18z"></path>
      </svg>
    );
  const label = (
    <>
      {icon}
      <span className="sr-only">{labelPrefix.trim()}</span>
    </>
  );

  const currentPageOffset = searchParams.get('start_rank') ? Number(searchParams.get('start_rank')) : 1;
  const currentPageNumber = getPageNumber(currentPageOffset, limit);
  const newPageNumber = direction === 'previous' ? currentPageNumber - 1 : currentPageNumber + 1;
  const newPageOffset = direction === 'previous' ? getPreviousOffset(currentPageOffset, limit) : getNextOffset(currentPageOffset, limit, summary.totalMatching);
  const isLink = itemType === 'link';
  const linkTo = isLink ? composePaginationLinkTo(newPageNumber, limit, searchParams) : '';

  const handleLinkClick = () => {
    setPage(newPageNumber);
  };

  const handleButtonClick = (e) => {
    const newSearchParams = new URLSearchParams(searchParams);
    setPage(newPageNumber);
    if (newPageOffset) {
      newSearchParams.set('start_rank', String(newPageOffset));
      setSearchParams(newSearchParams);
    }
  };

  return isLink ? (
    <li className="base-search-pagination-list__item">
      <Link to={linkTo} className="base-search-pagination-list__link" onClick={handleLinkClick}>
        {label}
      </Link>
    </li>
  ) : (
    <li className="base-search-pagination-list__item">
      <button type="button" onClick={handleButtonClick}>
        {label}
      </button>
    </li>
  );
};

export default PaginationControl;
